import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import heroParadise from "@/assets/hero-paradise-garden.jpg";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-hero-pattern">
      <div className="container relative z-10 py-10 md:py-16 lg:py-20">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Copy */}
          <div className="max-w-xl">
            <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] font-bold leading-[1.08] mb-4 text-balance">
              Design a Native Garden That Actually Works in Your Yard — in Minutes
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-muted-foreground mb-5 leading-relaxed max-w-lg">
              Get a personalized, location-based plan with plants that naturally thrive where you live — no guesswork required.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-2.5 max-w-md">
              <Link to="/create" className="w-full sm:w-auto">
                <Button variant="hero" size="xl" className="w-full sm:w-auto">
                  Start My Garden Plan (Free)
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
            <p className="text-sm text-foreground/70 mb-1 leading-relaxed max-w-md">
              Avoid costly mistakes. Choose plants that are built for your region.
            </p>
            <p className="text-xs text-muted-foreground">
              Built using regional growing data and native plant guidelines
            </p>
          </div>

          {/* Hero image */}
          <div className="order-first lg:order-last">
            <div className="rounded-2xl overflow-hidden shadow-xl border border-border/30">
              <img
                src={heroParadise}
                alt="Vibrant native pollinator garden with wildflowers in a residential yard"
                className="w-full aspect-[16/7] md:aspect-[16/8] object-cover"
                width={800}
                height={350}
                loading="eager"
                fetchPriority="high"
                decoding="sync"
              />
            </div>
            <p className="text-xs text-muted-foreground/60 mt-2 text-center">
              Example output from the planner
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
